import {ChartOptions} from 'chart.js';

export const Axes:number[] = [125,250,500,750,1000,1500,2000,3000,4000,6000,8000];
export const DashedAxes:number[] =  [750, 1500, 3000, 6000]; 
const getSize = () => {
  let innerWidth = window.innerWidth;
  if( innerWidth >= 992 && innerWidth <= 1170){
    return 13
  }
  // 992 1170
  return 20
} 
export const ChartOptionsConfig: ChartOptions<'line'> = {
    responsive : true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    layout: {
      padding: 20
    },
    scales: {
        ry: {
          min: -10,
          max: 120,
          position: 'right',
          reverse: true,
          ticks :{
            stepSize: 10,
            color: '#807F7F'
          },
          grid: {
            lineWidth: 1,
            tickColor: '#807F7F',
            color: '#807F7F',
            tickLength: 20,
          },
          border : {
            color:'#807F7F',
            width: 2
          }
        },
        y: {
          min: -10,
          max: 120,
          reverse: true,
          position: 'left',
          ticks :{
            stepSize: 10,
            color: '#807F7F',
          },
          grid: {
            lineWidth: 1,
            tickLength: 20,
            tickColor: '#807F7F',
          },
          border : {
            color:'#807F7F',
            width: 2
          },
          
        },
        x: {
            display : true,
            position: 'top',
            offset: true,
            border: {
              color:'#807F7F',
              dash: (item: any)=> {
                return  DashedAxes.indexOf(item.tick.label) !== -1 ? [5,5] : [];
              },
              dashOffset: 2
            },
            grid: {
              lineWidth: 1,
              drawTicks: true,
              tickColor: ({tick}:{ tick: any}) => {
                 return  tick.label == '' ? 'transparent' : '#807F7F';
              },
              color: '#807F7F'
            },
            ticks: {         
              callback : (value: any, index: any, values: any) => {
                let label = Axes[index];
                return  DashedAxes.indexOf(label) !== -1 ? label : '';
              },
              color: '#807F7F',
            },
            weight: 0
        },
        x1: {
          display : true,
          position: 'top',
          offset: true,
          border: {
              color:'#807F7F',
              display: false,
              dash: (item:any)=> {
                return  DashedAxes.indexOf(item.tick.label) !== -1 ? [5,5] : [];
              },
              dashOffset: 2
            },
            grid: {
              lineWidth: 1,
              drawTicks: true,
              tickLength: 20,
              tickColor: ({tick}: { tick: any}) => {
                 return  tick.label == '' ? 'transparent' : '#807F7F';
              },
              color: 'transparent',
            },
            weight: 0,
            ticks: {
              display: true,
              callback : (value:any, index:any, values: any) => {
                let label = Axes[index];
                return  DashedAxes.indexOf(label) === -1 ? label : '';
              },
              color: '#807F7F',               
            },
           
        }
       
    },
    plugins : {
      title: {
        display: true,
        position: 'bottom',
        text: "Frequency in Hertz (Hz)",
        font: {
          size: getSize(),
          weight: 'bold'
        }
      },
      legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              generateLabels: (chart: any) => {
                return  chart.data.datasets.map(
                    (dataset:any, index: any) => { 
                      let pointStyle = dataset.label == 'Right Ear' ? 'circle' : 'crossRot';
                      // console.log(dataset)
                      return {
                        text: dataset.label,
                        fillStyle: 'transparent',
                        strokeStyle: dataset.borderColor,
                        // pointStyle: pointStyle,
                        hidden: !chart.isDatasetVisible(index),
                        datasetIndex: index,
                        lineWidth: 1,
                        fontColor: "#000",
                        lineDash: dataset.borderDash
                       }
                    }
                  )
              }
            }
            
        },
      subtitle: {
            display: true,
            position: 'left',
            text: 'Hearing Level in dB (ANSI 1996)',
            font: {
                size: getSize(),
                weight: 'bold'
            }
        },
    }
   
};

export function getOptionConfig(){
     
    // if(ChartOptionsConfig.plugins?.legend?.labels?.generateLabels){
    //     ChartOptionsConfig.plugins.legend.labels.generateLabels = labelCallback;
    // }
    return { ...ChartOptionsConfig};
}